"use client";
import { Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorTextLink, FontLineHeightSm } from "@nxt-costco-com/forge-design-tokens";
import { LocationPinFilled } from "@nxt-costco-com/forge-icons/icons/LocationPinFilled";
import { ICON_SIZE_SM } from "./constants.js";
const StyledLink = styled(Link)({
  alignItems: "center",
  color: ColorTextLink,
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  textDecoration: "none"
});
const StyledLocationPin = styled(LocationPinFilled)(() => ({
  color: ColorTextLink,
  height: ICON_SIZE_SM,
  width: ICON_SIZE_SM
}));
const StyledText = styled(Text)(({ theme }) => ({
  color: ColorTextLink,
  [theme.breakpoints.up("xs")]: {
    fontSize: ".625rem",
    lineHeight: FontLineHeightSm
  },
  [theme.breakpoints.up("md")]: {
    ...theme.typography.t6
  },
  [theme.breakpoints.up("lg")]: {
    ...theme.typography.t5
  }
}));
export {
  StyledLink,
  StyledLocationPin,
  StyledText
};
